import { useState } from "react";
import { GOOGLE_MAPS_API_KEY } from "@/constants";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import { ProfileCard } from "./ProfileCard";
import CarMapPinIcon from "@/assets/icons/CarMapPinIcon.svg";
import CarMapPinActiveIcon from "@/assets/icons/CarMapPinActiveIcon.svg";
import { MarkerData } from "@/central-atoms/everest-fleet-pwa/types";

interface GMapProps {
  markers: MarkerData[];
  center: { lat: number; lng: number };
}

export const GMap: React.FC<GMapProps> = ({ markers, center }) => {
  const [activeMarkerIndex, setActiveMarkerIndex] = useState<number | null>(
    null
  );
  const [selectedProfile, setSelectedProfile] = useState<MarkerData | null>(
    null
  );

  const handleMarkerClick = (index: number, marker: MarkerData) => {
    setActiveMarkerIndex(index);
    setSelectedProfile(marker);
  };

  const handleCloseProfile = () => {
    setSelectedProfile(null);
    setActiveMarkerIndex(null);
  };

  return (
    <div>
      <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
        <Map
          style={{ height: "70vh" }}
          defaultCenter={center}
          gestureHandling={"greedy"}
          disableDefaultUI={true}
          defaultZoom={12}
        >
          {markers.map((marker, index) => (
            <Marker
              key={index}
              position={{ lat: marker.lat, lng: marker.lng }}
              icon={
                index === activeMarkerIndex
                  ? CarMapPinActiveIcon
                  : CarMapPinIcon
              }
              onClick={() => handleMarkerClick(index, marker)}
            />
          ))}
        </Map>
      </APIProvider>
      {selectedProfile && (
        <div className="absolute bottom-20 left-0 w-full flex justify-center p-4">
          <ProfileCard
            name={selectedProfile.name}
            et_id={selectedProfile.et_id}
            vehicle_number={selectedProfile.vehicle_number}
            phone={selectedProfile.phone}
            onClose={handleCloseProfile} // Pass the close handler
          />
        </div>
      )}
    </div>
  );
};
